import { ExprPath } from '../Switch';
import { ParseTree } from './ParseTree';
export var ParseView;
(function (ParseView) {
    function make(node) {
        const initial = [];
        const values = ParseTree.visit(initial, reducer, node);
        if (values instanceof Error) {
            return values;
        }
        return `digraph sample { \n ${values.join(';\n')} \n}`;
    }
    ParseView.make = make;
    function id(location) {
        const { location: { start, end }, } = location;
        return `"${start.line}:${start.offset}:${end.line}:${end.offset}"`;
    }
    function formatPath(node) {
        return ExprPath.makeAccessPath(node)
            .map((name) => `[${name}]`)
            .join('.');
    }
    function reducer(initial, node) {
        const nodeId = id(node);
        switch (node.type) {
            case "NullLiteral":
                return [`${nodeId} [label="NULL"]`, ...initial];
            case "BooleanLiteral": {
                const value = node.value === false ? 'FALSE' : 'TRUE';
                return [`${nodeId} [label="${value}"]`, ...initial];
            }
            case "HexLiteral":
            case "NumberLiteral":
                return [`${nodeId} [label="${node.value}"]`, ...initial];
            case "StringLiteral":
                return [`${nodeId} [label="'${node.value}'"]`, ...initial];
            case "DateLiteral":
                return [`${nodeId} [label="#${node.value}#"]`, ...initial];
            case "RegExpLiteral":
                return [`${nodeId} [label="/${node.value}/"]`, ...initial];
            case "Identifier":
            case "AccessIdentifier":
                return [`${nodeId} [label="[${node.name}]"]`, ...initial];
            case "AccessExpression":
                return [`${nodeId} [label="[${formatPath(node)}]"]`, ...initial];
            case "CallExpression":
                return [
                    `${nodeId} [label="${node.callee}"]`,
                    ...node.arguments.map((arg) => `${id(arg)} -> ${nodeId}`),
                    ...initial,
                ];
            case "UnaryExpression":
                return [
                    `${nodeId} [label="${node.operator}"]`,
                    `${id(node.operand)} -> ${nodeId}`,
                    ...initial,
                ];
            case "BinaryExpression":
                return [
                    `${nodeId} [label="${node.operator}"]`,
                    `${id(node.left)} -> ${nodeId}`,
                    `${id(node.right)} -> ${nodeId}`,
                    ...initial,
                ];
            case "LogicalExpression":
                return [
                    `${nodeId} [label="${node.operator}"]`,
                    `${id(node.left)} -> ${nodeId}`,
                    `${id(node.right)} -> ${nodeId}`,
                    ...initial,
                ];
            case "CaseExpression":
                return [`${nodeId} [label="CASE"]`, ...initial];
            case "CaseWhen":
                return [`${nodeId} [label="WHEN"]`, ...initial];
            case "CaseElse":
                return [`${nodeId} [label="ELSE"]`, ...initial];
            default:
                return initial;
        }
    }
})(ParseView || (ParseView = {}));
